import { useState } from 'react'
import { Layout } from '../components/Layout'
import { QRGenerator } from '../components/qr/QRGenerator'
import { defaultQRSettings, type QRSettings } from '../types/qr'
import './Home.scss'

export function Home() {
  const [settings, setSettings] = useState<QRSettings>(defaultQRSettings)

  return (
    <Layout>
      <div className="home-page">
        <QRGenerator settings={settings} onSettingsChange={setSettings} />
      </div>
    </Layout>
  )
}
